export function dropfile(state = [], action) {
  if (action.type === 'DROP_FILE') {
    return action.file;
  }
  return state;
}
